import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MdEdit, MdDelete } from "@onemind-services-llc/react-icons-ng/md";
import { ActionMenu } from "../../Menu";
import { DeleteModal } from "../../Modal/DeleteModal";
export const RenderActions = (props) => {
    const { name, data, withEdit = true, handleEdit = () => { }, withDelete = true, handleDelete = () => { }, extraOptions = [], modalDisclosure = {}, } = props;
    const { isOpen, onOpen = () => { }, onClose = () => { }, } = modalDisclosure;
    let menuList = [];
    if (withEdit) {
        menuList.push({
            label: "Edit",
            icon: _jsx(MdEdit, {}),
            onClick: handleEdit,
            "data-cy": "list_Edit",
        });
    }
    menuList = [...menuList, ...extraOptions];
    if (withDelete) {
        menuList.push({
            label: "Delete",
            icon: _jsx(MdDelete, {}),
            onClick: onOpen,
            "data-cy": "list_Delete",
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx(DeleteModal, { isOpen: isOpen, onClose: onClose, title: `Delete ${name}`, content: `Are you sure you want to delete ${(data === null || data === void 0 ? void 0 : data.display) || `this ${name.toLowerCase()}`} ?`, onDelete: handleDelete }), _jsx(ActionMenu, { menuList: menuList })] }));
};
export default RenderActions;
//# sourceMappingURL=renderActions.js.map